import {
    ANALISE_PRECO_MODO_TELA,
    ANALISE_PRECO_SET_AGUARDANDO,
    ANALISE_PRECO_LISTADO
} from './analisePrecoActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (
    state = INITIAL_STATE,
    action
) => {
    switch (action.type) {
        case ANALISE_PRECO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro:
                    action.payload.registro || {}
            };

        case ANALISE_PRECO_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case ANALISE_PRECO_LISTADO: {
            const lista =
                action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };
        }

        default:
            return state;
    }
};